import { Component } from '@angular/core';

import { FieldBaseComponent } from '../field-base';

@Component({
    selector: 'app-form-button',
    styleUrls: ['form-button.component.scss'],
    templateUrl: 'form-button.component.html'
})
export class FormButtonComponent extends FieldBaseComponent { }
